import { createRouter, createWebHistory } from 'vue-router';
import DashboardView from './views/DashboardView.vue';
import ToolsView from './views/ToolsView.vue';
import SitesView from './views/SitesView.vue';
import SettingsView from './views/SettingsView.vue';
import LogsView from './views/LogsView.vue';
import LoginView from './views/LoginView.vue';
import IntegrationsView from './views/IntegrationsView.vue';
import { fetchMe } from './auth';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/', name: 'dashboard', component: DashboardView },
    { path: '/ferramentas', name: 'tools', component: ToolsView },
    { path: '/sites', name: 'sites', component: SitesView },
    { path: '/integracoes', name: 'integrations', component: IntegrationsView },
    { path: '/logs', name: 'logs', component: LogsView },
    { path: '/configuracoes', name: 'settings', component: SettingsView },
  ],
});

router.beforeEach(async (to) => {
  if (to.meta.public) return true;
  const user = await fetchMe();
  if (!user) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  return true;
});
